<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_ix"></a>ACKNOWLEDGEMENTS</h2>
<p class="noindent"><span class="drop-cap">T</span>his book has been a long haul from its conception as ‘the book I always needed’ through to its finale during the Covid-19 pandemic of 2020.</p>
<p class="indent">There are many people who have believed in me through start to finish, starting with two of my teachers, Richard and Jean Lock of Duston Upper School in Northampton (Jean was the school librarian), who said that I had at least one book in me, if not a lot more. Then some chap from the Imperial War Museum, Peter Hart (I think he has written a couple of tomes!) chivvied me along. Latterly, I met Tara from Pen and Sword at Family Tree Live! at Alexandra Palace in 2019, who saw potential in it.</p>
<p class="indent">Next, I must thank Toby Brayley, from the Royal Military Police Museum for the two ‘Full Dress’ cavalry pictures and also WO2 Vinod Shrestha for his imposing example of a Gurkha soldier in uniform (for it is he).</p>
<p class="indent">I must also say thank you to members of my family who dug out pictures, including those of Great Uncle Don Roberts, late ASC and the joint picture of him and ‘little’ Uncle Fred Attridge, late DLI and AVC.</p>
<p class="indent">My wife, Angela, who has supported me throughout this enterprise, and read through everything, compared and then noticed missing badges in each section. A thankless task, but on the plus side she now knows a lot more about military badges!</p>
<p class="indent">I must also thank fellow former Poacher, Colonel Richard Kemp and Peter Hart for their kind words, along with another fellow former Poacher and badge collector, Ian Simpson, for his help over the years.</p>
<p class="indent">There are many, many others whom I should mention, and if this runs to a second edition, I promise you’ll be in!</p>
<p class="right">Sussex Weald, August, 2020.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Fm02.vue?6c991e48